module.exports = __webpack_public_path__ + "img/7@2x.85576e45.png";